module.exports = __webpack_public_path__ + "static/yourbackers-e00e5776b4b080150087e5cb9a473d9b.png";